import { render, staticRenderFns } from "./TagTypeEditPage.vue?vue&type=template&id=465e3b70"
import script from "./TagTypeEditPage.vue?vue&type=script&lang=ts"
export * from "./TagTypeEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports